// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-new-item-dialog {
  min-width: 500px;
  max-width: 600px;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media (max-width: 768px) {
  .add-new-item-dialog {
    min-width: 90vw;
    max-width: 90vw;
  }
}

::ng-deep .mat-dialog-container {
  padding: 0 !important;
  overflow: hidden;
}
::ng-deep .add-new-item-dialog-container .mat-dialog-content {
  margin: 0;
  padding: 0;
}
::ng-deep .add-new-item-dialog-container .mat-dialog-actions {
  margin: 0;
  padding: 0;
}
::ng-deep .add-new-item-dialog .mat-dialog-content {
  padding: 20px 24px !important;
  box-sizing: border-box;
}
::ng-deep .add-new-item-dialog .dialog-actions .mat-button,
::ng-deep .add-new-item-dialog .dialog-actions .mat-raised-button {
  margin: 0 !important;
  line-height: 1 !important;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
}
.dialog-header h2 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.dialog-header h2 .header-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.dialog-content {
  padding: 20px 24px !important;
  max-height: 60vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.image-preview-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
.image-preview-section .item-preview-image {
  width: 100%;
  max-width: 300px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e4e8f0;
  background: #f9fafb;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

.full-width {
  width: 100%;
}

.save-options-section {
  margin-top: 16px;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e4e8f0;
}
.save-options-section h3 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
.save-options-section .save-option-checkbox {
  display: block;
  margin-bottom: 8px;
}
.save-options-section .save-option-checkbox:last-child {
  margin-bottom: 0;
}
.save-options-section .save-options-hint {
  margin: 12px 0 0 0;
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 4px;
}

::ng-deep .add-new-item-dialog .mat-form-field {
  margin-bottom: 0;
  margin-top: 0;
  width: 100%;
}
::ng-deep .add-new-item-dialog .mat-form-field-wrapper {
  padding-bottom: 0;
  margin-bottom: 0;
}
::ng-deep .add-new-item-dialog .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 16px 14px !important;
  min-height: 56px;
}

.dialog-actions {
  padding: 20px 24px;
  border-top: 1px solid #e4e8f0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  min-height: 72px;
  box-sizing: border-box;
}
.dialog-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  min-width: 110px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 1;
  white-space: nowrap;
  margin: 0;
}
.dialog-actions button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.dialog-actions .cancel-btn {
  color: #6b7280;
  background: transparent;
  border: 1px solid #d1d5db;
}
.dialog-actions .cancel-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #374151;
}
.dialog-actions .save-btn {
  background: #5ea1d8;
  color: white;
  border: 1px solid #5ea1d8;
}
.dialog-actions .save-btn:hover:not(:disabled) {
  background: #4a8fc4;
  border-color: #4a8fc4;
  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.3);
}
.dialog-actions .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #9ca3af;
  border-color: #9ca3af;
}
@media (max-width: 768px) {
  .dialog-actions {
    padding: 16px;
    flex-direction: column-reverse;
    gap: 12px;
    min-height: auto;
  }
  .dialog-actions button {
    width: 100%;
    height: 44px;
    min-width: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/add-new-item-dialog/add-new-item-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;AACE;EARF;IASI,eAAA;IACA,eAAA;EAEF;AACF;;AAGE;EACE,qBAAA;EACA,gBAAA;AAAJ;AAII;EACE,SAAA;EACA,UAAA;AAFN;AAKI;EACE,SAAA;EACA,UAAA;AAHN;AAQI;EACE,6BAAA;EACA,sBAAA;AANN;AAYM;;EAEE,oBAAA;EACA,yBAAA;AAVR;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAbF;AAeE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAbJ;AAeI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAbN;AAiBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AAfJ;AAiBI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAfN;AAkBI;EACE,mBAAA;EACA,sBAAA;AAhBN;AAmBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjBN;;AAsBA;EACE,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AApBF;AAsBE;EALF;IAMI,0BAAA;EAnBF;AACF;;AAsBA;EACE,WAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAnBF;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,kBAAA;AApBJ;AAsBI;EACE,gBAAA;AApBN;AAwBE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAtBJ;;AA6BI;EACE,gBAAA;EACA,aAAA;EACA,WAAA;AA1BN;AA6BI;EACE,iBAAA;EACA,gBAAA;AA3BN;AA+BM;EACE,6BAAA;EACA,gBAAA;AA7BR;;AAmCA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAhCF;AAkCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;AAhCJ;AAkCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAhCN;AAoCE;EACE,cAAA;EACA,uBAAA;EACA,yBAAA;AAlCJ;AAoCI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAlCN;AAsCE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AApCJ;AAsCI;EACE,mBAAA;EACA,qBAAA;EACA,6CAAA;AApCN;AAuCI;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AArCN;AAyCE;EApEF;IAqEI,aAAA;IACA,8BAAA;IACA,SAAA;IACA,gBAAA;EAtCF;EAwCE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAtCJ;AACF","sourcesContent":[".add-new-item-dialog {\n  min-width: 500px;\n  max-width: 600px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  @media (max-width: 768px) {\n    min-width: 90vw;\n    max-width: 90vw;\n  }\n}\n\n// Override Material Dialog defaults\n::ng-deep {\n  .mat-dialog-container {\n    padding: 0 !important;\n    overflow: hidden;\n  }\n\n  .add-new-item-dialog-container {\n    .mat-dialog-content {\n      margin: 0;\n      padding: 0;\n    }\n\n    .mat-dialog-actions {\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  .add-new-item-dialog {\n    .mat-dialog-content {\n      padding: 20px 24px !important;\n      box-sizing: border-box;\n    }\n  }\n\n  .add-new-item-dialog {\n    .dialog-actions {\n      .mat-button,\n      .mat-raised-button {\n        margin: 0 !important;\n        line-height: 1 !important;\n      }\n    }\n  }\n}\n\n.dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n\n  h2 {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n\n    .header-icon {\n      color: #5ea1d8;\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .close-button {\n    color: #6b7280;\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    min-height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    border: 1px solid transparent;\n    padding: 0;\n    margin: 0;\n\n    &:hover {\n      background: #f3f4f6;\n      color: #374151;\n      border-color: #e5e7eb;\n    }\n\n    &:active {\n      background: #e5e7eb;\n      transform: scale(0.95);\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n    }\n  }\n}\n\n.dialog-content {\n  padding: 20px 24px !important;\n  max-height: 60vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.form-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.image-preview-section {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n\n  .item-preview-image {\n    width: 100%;\n    max-width: 300px;\n    max-height: 200px;\n    object-fit: contain;\n    border-radius: 8px;\n    border: 1px solid #e4e8f0;\n    background: #f9fafb;\n  }\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n\n  @media (max-width: 480px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.save-options-section {\n  margin-top: 16px;\n  padding: 16px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e4e8f0;\n\n  h3 {\n    margin: 0 0 12px 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n  }\n\n  .save-option-checkbox {\n    display: block;\n    margin-bottom: 8px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .save-options-hint {\n    margin: 12px 0 0 0;\n    font-size: 12px;\n    color: #6b7280;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n}\n\n// Ensure proper spacing and padding for Material form fields\n::ng-deep {\n  .add-new-item-dialog {\n    .mat-form-field {\n      margin-bottom: 0;\n      margin-top: 0;\n      width: 100%;\n    }\n\n    .mat-form-field-wrapper {\n      padding-bottom: 0;\n      margin-bottom: 0;\n    }\n\n    .mat-form-field-appearance-outline {\n      .mat-form-field-infix {\n        padding: 16px 14px !important;\n        min-height: 56px;\n      }\n    }\n  }\n}\n\n.dialog-actions {\n  padding: 20px 24px;\n  border-top: 1px solid #e4e8f0;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  margin: 0;\n  min-height: 72px;\n  box-sizing: border-box;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    height: 40px;\n    min-width: 110px;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    box-sizing: border-box;\n    line-height: 1;\n    white-space: nowrap;\n    margin: 0;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      line-height: 18px;\n    }\n  }\n\n  .cancel-btn {\n    color: #6b7280;\n    background: transparent;\n    border: 1px solid #d1d5db;\n\n    &:hover {\n      background: #f9fafb;\n      border-color: #9ca3af;\n      color: #374151;\n    }\n  }\n\n  .save-btn {\n    background: #5ea1d8;\n    color: white;\n    border: 1px solid #5ea1d8;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n      border-color: #4a8fc4;\n      box-shadow: 0 2px 4px rgba(94, 161, 216, 0.3);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      background: #9ca3af;\n      border-color: #9ca3af;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px;\n    flex-direction: column-reverse;\n    gap: 12px;\n    min-height: auto;\n\n    button {\n      width: 100%;\n      height: 44px;\n      min-width: unset;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
